export default __webpack_public_path__ + "img/ae30730204b16d2e8d1668f2e8b5dab2.png";